/**
 * This script handles generic tracking
 */

import * as Cookies from 'js-cookie';

/**
 * Function adds tracking to dataLayer
 *
 * @param {object} data  tracking data
 * @returns {void}
 */
export function gtmTrack(data: object) {
	if ((window as any).dataLayer) {
		(window as any).dataLayer.push(data);
	}
}

/**
 * Persist Sitecore Analytics consent to technical cookie.
 * @param active true if consent is given; otherwise, false.
 */
function setSitecoreAnalyticsCookiePref(active: boolean) {
	Cookies.set('track_sc_allowed', active ? 'true' : 'false', { expires: 3650 });
}

/**
 * Check consent status on load.
 * - Check for Sitecore Analytics consent.
 * - Check for Marketo consent.
 */
(window as any).addEventListener('UC_UI_INITIALIZED', function (e: CustomEvent) {
	const services = (window as any).UC_UI.getServicesBaseInfo() as any[];

	// Sitecore
	var sc = services.find(s => s.name === "Sitecore");
	setSitecoreAnalyticsCookiePref(sc && sc.consent && sc.consent.status);

	// Marketo
	var mkto = services.find(s => s.name === "Marketo")
	if (mkto && mkto.consent && mkto.consent.status) {
		checkMarketoEmailLink();
	} else {
		setKnownMarketoLead(false);
	}
});

/**
 * Handle Usercentrics consent changes. Check for Sitecore Analytics consent.
 */
(window as any).addEventListener("ucEvent", function (e: CustomEvent) {
	if (e.detail && e.detail.event == "consent_status") {
		const sitecorePurposeName = "Sitecore";
		if (e.detail[sitecorePurposeName] === true) {
			setSitecoreAnalyticsCookiePref(true);
		}
		else {
			setSitecoreAnalyticsCookiePref(false);
		}

		const marketoPurposeName = "Marketo";
		if (e.detail[marketoPurposeName] === true) {
			checkMarketoEmailLink();
		} else {
			setKnownMarketoLead(false);
		}
	}
});

export function isKnownMarketoLead(): boolean {
	let cookieValue = Cookies.get("mkto_submitted");
	if (cookieValue != undefined) {
		if (cookieValue.length > 0) {
			return true;
		}
	}
	return false;
}

export function isKnownCdcLead(): boolean {
	let cookieValue = Cookies.get("cdc_submitted");
	if (cookieValue != undefined) {
		if (cookieValue.length > 0) {
			return true;
		}
	}
	return false;
}

export function setKnownMarketoLead(state: boolean): void {
	if (state) {
		Cookies.set("mkto_submitted", "1", { expires: 365 });
	} else {
		Cookies.remove("mkto_submitted");
	}
}

export function setKnownCdcLead(state: boolean): void {
	if (state) {
		Cookies.set("cdc_submitted", "1", { expires: 365 });
	} else {
		Cookies.remove("cdc_submitted");
	}
}

function checkMarketoEmailLink(): void {
	const queryStr = window.location.search.substring(1);
	const querySet = queryStr.split("&");
	for (let i = 0; i < querySet.length; i++) {
		if (querySet[i].indexOf("mkt_tok") === 0) {
			setKnownMarketoLead(true);
			return;
		}
	}
}
